import type { HomeActivity } from '@/hooks/useHomeDashboard';
import { renderFileIcon } from '@/lib/document-icons';
import { cn } from '@/lib/utils';
import { formatRelativeTime } from '@/utils/date-utils';

function fullFilePath(item: HomeActivity): string | undefined {
  const folderPath = item.folder_path?.trim();
  if (!folderPath) return item.title || undefined;
  const base = folderPath.endsWith('/') ? folderPath.slice(0, -1) : folderPath;
  return `${base}/${item.title}`;
}

export function RecentUploadRow({
  item,
  onOpen,
}: {
  item: HomeActivity;
  onOpen: (item: HomeActivity) => void;
}) {
  const pathTooltip = fullFilePath(item);
  return (
    <li>
      <button
        type="button"
        title={pathTooltip}
        onClick={() => onOpen(item)}
        className={cn(
          'group flex w-full items-start gap-3 rounded-xl py-2.5 text-left',
          'transition-colors hover:bg-slate-50 -mx-2 px-2',
        )}
      >
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-50">
          {renderFileIcon(item.title, 'h-4 w-4')}
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-sm font-normal text-slate-700 underline-offset-2 group-hover:text-slate-900 group-hover:underline">
            {item.title}
          </span>
          <span className="mt-0.5 block truncate text-xs text-muted-foreground">
            {[item.document_type, item.matter_name].filter(Boolean).join(' · ')}
          </span>
        </span>
        <span className="shrink-0 text-[11px] text-slate-400">
          {formatRelativeTime(item.occurred_at)}
        </span>
      </button>
    </li>
  );
}
